export const skinEdit = {
    id: 'skin-edit',
    schemaVersion: 2,
    covers: 'A hook, several statements, then an end card carrying an offer and a call to action. Suits a service pitch that closes on something concrete.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 759,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 6],
                    },
                    required: true,
                },
                fit: 'cover',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 0,
                            transition: {
                                mask: 'oval-iris',
                            },
                        },
                        {
                            atSec: 0.3,
                            transition: 'fade',
                        },
                        {
                            atSec: 4.13,
                            transition: {
                                mask: 'corner-l-wipe',
                            },
                        },
                        {
                            atSec: 7.733,
                            transition: 'fade',
                        },
                        {
                            atSec: 8,
                            transition: 'fade',
                        },
                        {
                            atSec: 20.3,
                            transition: 'fade',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'card-0',
                start: {
                    at: 'frame',
                    value: 609,
                },
                duration: {
                    kind: 'fixed',
                    frames: 150,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#120D07',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                        adoptLogoScrim: true,
                    },
                },
            },
            {
                kind: 'group',
                id: 'scene-0',
                duration: {
                    kind: 'fixed',
                    frames: 130,
                },
                start: {
                    at: 'frame',
                    value: 10,
                },
                placement: {
                    anchor: 'center',
                    x: 0.499,
                    y: 0.2914,
                    width: 0.72,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 101.3,
                                fontWeight: 500,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'typewriter',
                            entranceDurationFrames: 34,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 67.7,
                                fontWeight: 500,
                                fontStyle: 'italic',
                                lineHeight: 1.11,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'letter-fade-scattered',
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-1',
                duration: {
                    kind: 'fixed',
                    frames: 85,
                },
                start: {
                    at: 'frame',
                    value: 150,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.502,
                    y: 0.813,
                    width: 0.78,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 91.9,
                                fontWeight: 500,
                                lineHeight: 1.09,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'word-by-word-reverse',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 91.9,
                                fontWeight: 500,
                                fontStyle: 'italic',
                                lineHeight: 1.09,
                                whiteSpace: 'nowrap',
                            },
                            motion: {
                                token: 'word-by-word',
                                delayFrames: 7,
                            },
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-2',
                duration: {
                    kind: 'fixed',
                    frames: 220,
                },
                start: {
                    at: 'frame',
                    value: 240,
                },
                placement: {
                    anchor: 'top',
                    x: 0.497,
                    y: 0.1999,
                    width: 0.92,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement3',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 63.8,
                                fontWeight: 500,
                                lineHeight: 1.105,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'word-by-word',
                            entranceDurationFrames: 14,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'label',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 63.8,
                                fontWeight: 500,
                                fontStyle: 'italic',
                                lineHeight: 1.105,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 13,
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-3',
                duration: {
                    kind: 'fixed',
                    frames: 152,
                },
                start: {
                    at: 'frame',
                    value: 463,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.499,
                    y: 0.8434,
                    width: 0.92,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement4',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 60,
                                fontWeight: 500,
                                lineHeight: 1.1,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'word-by-word',
                            entranceDurationFrames: 12,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement5',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 60,
                                fontWeight: 500,
                                lineHeight: 1.1,
                                whiteSpace: 'nowrap',
                            },
                            motion: {
                                token: 'word-by-word',
                                durationFrames: 20,
                                delayFrames: 5,
                            },
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'brand-card-0',
                start: {
                    at: 'frame',
                    value: 620,
                },
                duration: {
                    kind: 'fixed',
                    frames: 139,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5079,
                    y: 0.3692,
                    width: 0.62,
                },
                root: {
                    kind: 'logo',
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    width: 1,
                    entrance: 'fade-in',
                    entranceDurationFrames: 20,
                },
            },
            {
                kind: 'rect',
                id: 'bar-offer',
                start: {
                    at: 'frame',
                    value: 619,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5007,
                    y: 0.5805,
                    width: 0.7986,
                    height: 0.0625,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-offer',
                start: {
                    at: 'frame',
                    value: 619,
                },
                duration: {
                    kind: 'fixed',
                    frames: 140,
                },
                placement: {
                    anchor: 'center',
                    x: 0.498,
                    y: 0.5761,
                    width: 0.78,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 300,
                                fontStyle: 'italic',
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 300,
                                fontStyle: 'italic',
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-cta',
                start: {
                    at: 'frame',
                    value: 627,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.4993,
                    y: 0.6375,
                    width: 0.7986,
                    height: 0.0234,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-cta',
                start: {
                    at: 'frame',
                    value: 627,
                },
                duration: {
                    kind: 'fixed',
                    frames: 132,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4986,
                    y: 0.6374,
                    width: 0.9,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'cta',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 34.4,
                                fontWeight: 100,
                                lineHeight: 1.1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.11,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-tagline',
                start: {
                    at: 'frame',
                    value: 632,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.7656,
                    width: 0.9138,
                    height: 0.0516,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-tagline',
                start: {
                    at: 'frame',
                    value: 632,
                },
                duration: {
                    kind: 'fixed',
                    frames: 127,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4996,
                    y: 0.7652,
                    width: 0.86,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 100,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.048,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 100,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.048,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 18,
            description: 'Names the offer, line 1 — what KIND of offer it is, not the treatment. Source shape: "A Limited".',
        },
        hook2: {
            type: 'text',
            maxChars: 23,
            description: 'Line 2 of the offer\'s name, set italic. Source shape: "Mid-Week Treat". Reads as one phrase with `hook`.',
        },
        statement: {
            type: 'text',
            maxChars: 21,
            description: 'Beat two, line 1 — the ACTION to take, as an instruction. Source shape: "Book any of our".',
        },
        statement2: {
            type: 'text',
            maxChars: 22,
            description: 'Completes the action, italic, naming what is being booked. Source shape: "bespoke facials".',
        },
        statement3: {
            type: 'text',
            maxChars: 30,
            description: 'Beat three, line 1 — what is thrown in ON TOP. Begins with \'and\': it continues beat two rather than restarting. Source shape: "and receive a complimentary".',
        },
        label: {
            type: 'text',
            maxChars: 31,
            description: 'The italic line naming the included extra. Source shape: "Alumier Eye Treatment."',
        },
        statement4: {
            type: 'text',
            maxChars: 33,
            description: 'Beat four, line 1 — the BENEFIT of that extra, in the client\'s terms. May carry *italic* runs. Source shape: "The ultimate cure for hydration".',
        },
        statement5: {
            type: 'text',
            maxChars: 33,
            description: 'Completes the benefit and sets up the end card. May carry *italic* runs. Source shape: "and reduced puffy eyes."',
        },
        offer1: {
            type: 'text',
            maxChars: 34,
            description: "The first of two lines naming something CONCRETE the viewer can take up — a consultation, a patch test, a named treatment, a specific package. Name the thing itself; 'our range of services' is not an offer. Set in italic sans, apart from the rest of the card.",
        },
        offer2: {
            type: 'text',
            maxChars: 34,
            description: 'The second offer line, completing the first rather than starting a new one — the condition, the timing, or what is included. The two lines are read together as one offer.',
        },
        cta: {
            type: 'text',
            maxChars: 46,
            description: "The end-card call to action: the single action to take, as a verb phrase — 'Book a consultation', 'Message us to check your suitability'. An instruction, not a slogan. May carry **bold** runs on the words that matter.",
        },
        tagline1: {
            type: 'text',
            maxChars: 30,
            description: "The first of two closing tagline lines — the clinic's standing promise, not anything specific to this treatment. May carry *italic* runs.",
        },
        tagline2: {
            type: 'text',
            maxChars: 30,
            description: 'The second tagline line, completing the first. The two are read as one phrase, so it must not restate line one.',
        },
    },
    structure: 'A limited offer, built in four beats that run on from each other: name the offer, state the action to take, state what is thrown in with it, then the benefit. The source is: "A Limited / Mid-Week Treat" — "Book any of our / bespoke facials" — "and receive a complimentary / Alumier Eye Treatment." — "The ultimate cure for hydration / and reduced puffy eyes." Note the third beat begins with "and": it continues the second, it does not restart.',
};
//# sourceMappingURL=skin-edit.js.map